import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const useGetHistoryDisabledState = () =>
    usePlacementStore(
        (state) =>
            state.isViewMode ||
            state.isHistoryTransactionActive ||
            state.isAutoDragActiveRef.current ||
            state.isDragNewArticleStartRef.current
    );
